/* eslint-disable quotes */
<template>
    <div>
        <nav-bar />
        <!--blog Section start-->
        <div class="page-margin">
            <!--breadcrumb start-->
            <div class="breadcrumb-bg">
                <div class="container">
                    <div class="row">
                        <div
                            class="col-md-6 col-sm-6 col-text-center d-align-center"
                        >
                            <h2 class="title"><span>AirByXtreme</span></h2>
                        </div>
                        <div class="col-md-6 col-sm-6 col-text-center">
                            <nav
                                aria-label="breadcrumb"
                                class="blog-bradcrumb "
                            >
                                <ol class="breadcrumb bg-transparent mb-0">
                                    <li class="breadcrumb-item">
                                        <a :href="'/'">Home</a>
                                    </li>
                                    <li class="breadcrumb-item active">
                                        <a href="">Demo</a>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <!--breadcrumb end -->
            <!-- sign in -->
            <section>
                <div class="innerpage-decor">
                    <div class="innerpage-circle1">
                        <img
                            :src="require('@/assets/images/Testimonial2.png')"
                            alt=""
                        />
                    </div>
                    <div class="innerpage-circle2">
                        <img
                            :src="require('@/assets/images/Testimonial1.png')"
                            alt=""
                        />
                    </div>
                </div>
                <h2 class="review-header text-center mx-auto">
                    AirByXtreme is the innovative, smart hospitality solution
                    for hotels & residences. <br /><br />Our application is
                    completely customisable and uses BYOD technology, allowing
                    the customer to manage functions and set preferences from
                    their own device.
                </h2>
                <div class="review-block">
                    <div class="container">
                        <div class="row margin-bottom">
                            <div class="col-lg-6 col-md-6">
                                <div class="review-box">
                                    <img
                                        :src="
                                            require('@/assets/images/features/energy.png')
                                        "
                                        alt="review"
                                        class="img-fluid"
                                    />
                                    <h5>Reduce consumption & cut costs</h5>
                                    <div class="review-message">
                                        <p>
                                            Improve your eco-credentials through
                                            smarter energy use and, at the same
                                            time,<br /><br />
                                            watch your energy costs fall with
                                            the dynamic management of heating,
                                            air conditioning, lights and
                                            appliances.
                                            <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="review-box">
                                    <img
                                        :src="
                                            require('@/assets/images/features/mac.png')
                                        "
                                        alt="review"
                                        class="img-fluid"
                                    />
                                    <h5>Detailed analytics & data capture</h5>
                                    <div class="review-message">
                                        <p>
                                            Receive detailed analytics on how
                                            your hotel is used and become more
                                            efficient across your operational
                                            structure.<br /><br />
                                            Define and set rules on when
                                            lighting, air-con and TVs should be
                                            automatically switched on/off.
                                            <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="review-box">
                                    <img
                                        :src="
                                            require('@/assets/images/features/phone_arm.png')
                                        "
                                        alt="review"
                                        class="img-fluid"
                                    />
                                    <h5>
                                        Guests can access and control their room
                                        using their smartphone
                                    </h5>
                                    <div class="review-message">
                                        <p>
                                            Contactless entry, from a single
                                            link, via any internet-enabled
                                            device.<br /><br />
                                            No download, no passwords to
                                            remember <br />
                                            just a hassle-free solution for you
                                            and your guests
                                            <br />
                                            <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                                <div class="review-box">
                                    <img
                                        :src="
                                            require('@/assets/images/features/mobile2.png')
                                        "
                                        alt="review"
                                        class="img-fluid"
                                    />
                                    <h5>
                                        Streamline the customer journey & build
                                        meaningful engagements
                                    </h5>
                                    <div class="review-message">
                                        <p>
                                            Invest in the right technology to
                                            elevate your guests’ experiences.<br /><br />
                                            Maintain your reputation for
                                            excellent customer service,
                                            cultivating new and repeat business.
                                            Our application provides a direct
                                            channel of communication to your
                                            customer.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- sign up -->
            <div class="text-center">
                <b-btn
                    color="#93fbd9"
                    href="https://demos.xtremecontrols.co.uk/#/Hospitality"
                    class="mb-5 mx-auto contBtn p-4"
                    x-large
                >CONTINUE TO THE DEMO</b-btn
                >
            </div>

            <!--Footer Section start-->
            <Footer />
            <js />
            <!--Footer Section End-->
        </div>
        <!--blog Section end-->
    </div>
</template>
<script>
// eslint-disable-next-line quotes
import NavBar from "../components/navbar.vue"

export default {
    components: { NavBar },
    name: "hospitality_features"
}
</script>
<style>
.review-block {
    background-image: url("../assets/images/1.png");
    background-repeat: no-repeat;
}
.contBtn {
    color: #000;
    border: none;
}

.review-box {
    margin-top: 30px !important;
}

.review-box img {
    height: 200px !important;
    border-radius: 0% !important;
}

.review-box h5 {
    font-size: 22px;
    margin-bottom: 25px;
}

.review-box p {
    font-size: 18px;
}

.review-header {
    max-width: 900px;
    text-transform: none !important;
}

.review-header {
    line-height: 50px !important;
}

@media only screen and (max-width: 600px) {
    .review-box img {
        height: 100px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/hospitality_features.vue